<template>
  <div class="index">
    <div class="main-wrap">
      <div>
        <div class="wrapper">
          <el-button
            type="primary"
            @click="departmentAdd"
            class="button-search icon-plus-button"
            size="mini">添加计划任务
          </el-button>
          <jm-crumbs/>
          <div class="table-agile-info">
            <div class="edit-bg-wrap">
              <div class="common-new-title mode2">
                <span>计划任务</span>
              </div>
              <el-tabs v-model="tab1" @tab-click="changeTab" class="tabpane-mode2">
                <el-tab-pane label="今日" name="today"></el-tab-pane>
                <el-tab-pane label="明日" name="+1day"></el-tab-pane>
                <el-tab-pane label="后日" name="+2day"></el-tab-pane>
                <el-tab-pane label="7日内" name="+7day"></el-tab-pane>
                <el-tab-pane label="全部" name=""></el-tab-pane>
              </el-tabs>
              <jm-tableList
                style="width: 98%; margin: auto"
                url="/index/Plantask/index"
                :search-data="{searchType: tab1}"
                :refresh.sync="refresh">
                <el-table-column
                  slot="tk_name"
                  label="学生">
                  <template slot-scope="scope">
                    <router-link
                      :to="scope.row.tk_url"
                      v-if="scope.row.crm_id"
                      target="_blank">{{ scope.row.tk_name }}
                    </router-link>
                    <span v-else>{{ scope.row.tk_name }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  slot="tk_memo"
                  label="说明">
                  <template slot-scope="scope">
                    <p class="memo">{{ scope.row.tk_memo }}</p>
                  </template>
                </el-table-column>
                <el-table-column
                  slot="lastColumn"
                  label="操作"
                  width="400"
                  align="left">
                  <template slot-scope="scope">
                    <div class="index-table-btnwrap">
                      <router-link
                        :to="scope.row.tk_url"
                        v-if="scope.row.crm_id"
                        target="_blank">
                        <el-button type="primary" size="mini">用户详情</el-button>
                      </router-link>
                      <el-button
                        v-if="scope.row.tk_pass === 0"
                        type="primary"
                        @click="departmentEdit(scope)"
                        size="mini">查看/编辑
                      </el-button>
                      <el-button
                        v-if="scope.row.tk_type === '预约回访'"
                        size="mini"
                        type="success"
                        @click="visitHandle({ crmid: scope.row.crm_id }, 'visit', '快捷回访')">回访
                      </el-button>
                      <el-select v-if="scope.row.tk_pass_str === '待处理'" class="jm-input90" v-model="scope.row.tk_pass1"
                                 @change="departmentChangePass(scope)" placeholder="请选择">
                        <el-option
                          key="0"
                          label="待处理"
                          value="0">
                        </el-option>
                        <el-option
                          key="1"
                          label="已处理"
                          value="1">
                        </el-option>
                        <el-option
                          key="2"
                          label="已取消"
                          value="2">
                        </el-option>
                      </el-select>
                    </div>
                  </template>
                </el-table-column>
              </jm-tableList>
              <!--仅咨询,质检（81）可以显示如下待处理资源列表-->
              <div v-if="$hasPermission([20, 22, 23, 29, 33, 36, 38, 39, 40, 43, 51, 54, 56, 57, 71, 81, 88, 101, 121, 122, 124, 129, 131, 142, 143, 147, 148])">
                <div style="margin-top: 44px" class="common-new-title mode2">
                  <span>待处理资源列表</span>
                </div>
                <el-row class="search-wrap">
                  <el-col :span="8" v-if="$hasPermission([20, 22, 23, 29, 33, 36, 38, 39, 40, 43, 51, 54, 56, 57, 71, 81, 88, 101, 121, 122, 124, 129, 131, 142, 143, 147, 148])">
                    <p>
                      <span>搜索类型：</span>
                      <el-select v-model="tab2" @change="changeTab2" placeholder="请选择" class="jm-input-common4">
                        <el-option
                          v-for="item in dict.formType2"
                          :key="item.value"
                          :label="item.title"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </p>
                  </el-col>
                  <el-col :span="8" v-if="$hasPermission([81])">
                    <span style="margin-left: 30px">角色搜索：</span>
                    <el-select v-model="searchData.roleid" @change="changeStudentType" placeholder="全部角色" clearable class="jm-input-common4">
                      <el-option
                        v-for="item in options.roleids"
                        :key="item.roleid"
                        :label="item.name"
                        :value="item.roleid"/>
                    </el-select>
                  </el-col>
                  <el-col :span="8" v-if="$hasPermission([22, 33, 36, 39, 42, 51, 101, 121, 122, 142, 148])">
                    <span style="margin-left: 30px">员工搜索：</span>
                    <el-select v-model="searchData.searchTeacher" @change="changeStudentType" placeholder="全部员工" clearable class="jm-input-common4">
                      <el-option
                        v-for="item in options.teachers"
                        :key="item.key"
                        :label="item.name"
                        :value="item.key"/>
                    </el-select>
                  </el-col>
                </el-row>

                <el-tabs v-model="tab3" @tab-click="changeStudentType" class="tabpane-mode2">
                  <el-tab-pane
                    v-for="item in formType3"
                    :key="item.value"
                    :name="item.value">
                    <span slot="label">
                      {{ item.title }}
                      <el-tooltip
                        placement="top"
                        effect="light">
                        <div slot="content">
                          {{ item.remark }}
                        </div>
                        <i class="el-icon-question blue"/>
                      </el-tooltip>
                    </span>
                  </el-tab-pane>
                </el-tabs>
                <span class="red">注：以下标记资源均为今日需要处理资源，并非当前违规资源。</span>
                <jm-tableList
                  style="width: 98%; margin: auto"
                  url="/index/Plantask/students"
                  :search-data="searchData"
                  :refresh.sync="refresh1">
                  <el-table-column
                    slot="custom_name"
                    label="学生"
                    width="200">
                    <template slot-scope="scope">
                      <router-link
                        :to="{ name: 'editStudent', params: { id: scope.row.id } }"
                        target="_blank">
                        <span :class="getClass(scope.row, 'custom_name')">
                          【{{ scope.row.custom_name }}{{ scope.row.custom_nickname_tell ? `/ ${scope.row.custom_nickname_tell}` : '' }}】
                          <span v-if="scope.row.crm_tel"><br/>Tel:{{ scope.row.crm_tel }}</span>
                          <span v-if="scope.row.crm_qq"><br/>QQ:{{ scope.row.crm_qq }}</span>
                          <span v-if="scope.row.crm_weixin"><br/>微信:{{ scope.row.crm_weixin }}</span>
                        </span>
                      </router-link>
                    </template>
                  </el-table-column>
                  <el-table-column
                    slot="member_level"
                    label="用户分级">
                    <template slot-scope="scope">
                      <span :class="getClass(scope.row, 'member_level')">{{ scope.row.member_level }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    slot="lastvisitcount"
                    label="回访次数">
                    <template slot-scope="scope">
                      <span :class="getClass(scope.row, 'lastvisitcount')">{{ scope.row.lastvisitcount }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    slot="lastvisittime2"
                    label="最后回访时间">
                    <template slot-scope="scope">
                      <span :class="getClass(scope.row, 'lastvisittime2')">{{ scope.row.lastvisittime2 }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    slot="lastColumn"
                    label="操作"
                    width="200"
                    align="left">
                    <template slot-scope="scope">
                      <el-button
                        type="primary"
                        size="mini">
                        <router-link
                          :to="{ name: 'editStudent', params: { id: scope.row.id } }"
                          target="_blank">
                          <span>用户详情</span>
                        </router-link>
                      </el-button>
                      <el-button
                        size="mini"
                        type="success"
                        @click="visitHandle({ crmid: scope.row.id }, 'visit', '快捷回访')">回访
                      </el-button>
                    </template>
                  </el-table-column>
                </jm-tableList>

              </div>
              <!--仅文案可显示-->
              <div v-if="$hasPermission([1, 58, 33])">
                <div style="margin-top: 44px" class="common-new-title mode2">
                  <span>文案待处理资源列表</span>
                </div>
                <el-row class="search-wrap">
                  <el-col :span="8">
                    <span>员工搜索：</span>
                    <el-select v-model="searchData.writeTeacher" @change="changeWriteTeacher" placeholder="全部员工" clearable class="jm-input-common4">
                      <el-option
                        v-for="item in options.writeTeachers"
                        :key="item.key"
                        :label="item.name"
                        :value="item.key"/>
                    </el-select>
                  </el-col>
                </el-row>

                <jm-tableList
                  style="width: 98%; margin: auto"
                  url="/index/write_visit/plantaskTable"
                  :search-data="searchData"
                  :refresh.sync="refresh2">
                  <el-table-column
                    slot="lastColumn"
                    label="操作"
                    width="200"
                    align="left">
                    <template slot-scope="scope">
                      <el-button
                        type="primary"
                        size="mini">
                        <router-link
                          :to="{ name: 'editStudent', params: { id: scope.row.studentid } }"
                          target="_blank">
                          <span>用户详情</span>
                        </router-link>
                      </el-button>
                      <el-button
                        size="mini"
                        type="success"
                        @click="visitHandle({ crmid: scope.row.studentid }, 'visit', '文案快捷回访', 'increase', 'writeOperate')">回访
                      </el-button>
                    </template>
                  </el-table-column>
                </jm-tableList>

              </div>
              <!--仅日本规划，日本规划主管可以显示如下待处理资源列表-->
              <div v-if="$hasPermission([140, 141])">
                <div style="margin-top: 44px" class="common-new-title mode2">
                  <span>规划待处理资源列表</span>
                </div>
                <el-row class="search-wrap" v-if="$hasPermission(140)">
                  <el-col :span="8">
                    <span>员工搜索：</span>
                    <el-select v-model="searchData.planningTeacher" @change="changePlanningTeacher" placeholder="全部员工" clearable class="jm-input-common4">
                      <el-option
                        v-for="item in options.planningTeachers"
                        :key="item.key"
                        :label="item.name"
                        :value="item.key"/>
                    </el-select>
                  </el-col>
                </el-row>

                <jm-tableList
                  style="width: 98%; margin: auto"
                  url="/index/plan_visit/plantaskTable"
                  :search-data="searchData"
                  :refresh.sync="refresh3">
                  <el-table-column
                    slot="lastColumn"
                    label="操作"
                    width="200"
                    align="left">
                    <template slot-scope="scope">
                      <el-button
                        type="primary"
                        size="mini">
                        <router-link
                          :to="{ name: 'editStudent', params: { id: scope.row.studentid } }"
                          target="_blank">
                          <span>用户详情</span>
                        </router-link>
                      </el-button>
                      <el-button
                        size="mini"
                        type="success"
                        @click="visitHandle({ crmid: scope.row.studentid }, 'visit', '规划快捷回访', 'increase', 'planningOperate')">回访
                      </el-button>
                    </template>
                  </el-table-column>
                </jm-tableList>
              </div>
            </div>
            <el-dialog
              title="计划任务"
              :visible.sync="dialogFormVisible"
              v-if="dialogFormVisible"
              @close="cancel">
              <el-form
                :model="form"
                :rules="rules"
                ref="form"
                label-width="80px"
                inline>
                <el-row>
                  <el-col :span="24">
                    <el-form-item
                      label="时间："
                      prop="tk_time">
                      <el-date-picker
                        class="jm-input220"
                        v-model="form.tk_time"
                        type="datetime"
                        placeholder="选择日期时间"
                        @change="sayTime"/>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item
                      label="性质："
                      prop="tk_type">
                      <el-select
                        v-model="form.tk_type"
                        placeholder="请选择"
                        :disabled="setDisabled">
                        <el-option
                          v-for="item in options.type"
                          :key="item.key"
                          :label="item.value"
                          :value="item.key"/>
                      </el-select>
                    </el-form-item>
                    <el-form-item
                      label="学生："
                      prop="tk_name"
                      v-if="form.tk_type && form.tk_type < 3">
                      <el-select
                        v-model="form.tk_name"
                        filterable
                        remote
                        clearable
                        :disabled="setDisabled"
                        placeholder="学生姓名"
                        :remote-method="getStudent"
                        :loading="loading">
                        <el-option
                          v-for="item in students"
                          :key="item.crm_id"
                          :label="item.content"
                          :value="`${item.content}#${item.crm_id}`"
                        />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="24">
                    <el-form-item
                      label="说明："
                      prop="tk_memo">
                      <el-input
                        type="textarea"
                        :rows="3"
                        placeholder="请输入内容"
                        v-model="form.tk_memo"
                        class="menu"/>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
              <div
                slot="footer"
                class="dialog-footer">
                <el-button @click="cancel">取 消</el-button>
                <el-button
                  type="primary"
                  @click="submitForm">保 存
                </el-button>
              </div>
            </el-dialog>
            <!--快捷回访 预约回访 父层组件 S-->
            <jm-visit-form-dialog
              :visible.sync="visitVisible"
              :title="visitDialogTitle"
              :type="visitType"
              :data-set="visitData"
              :operate-visit="userOperateVisit"
              @finished="finished"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .menu{
    width: 500px;
  }

  .memo{
    overflow: hidden;
    white-space: nowrap;
    -ms-text-overflow: ellipsis;
    text-overflow: ellipsis;
  }

  .blue{
    color: #3368fa;
  }

  .red{
    color: #F75694;
    padding: 10px 20px;
  }

  .red1{
    color: #F75694;
  }
  .search-wrap{
    padding: 30px 50px;
  }
  .search-wrap span{
    font-weight: bold;
  }
</style>
<script>
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';
import tableList from '@/components/data/tableList.vue';
import visitFormDialog from '@/components/tool/visitFormDialog.vue';
import student from '../student/student';
import plantaskDict from '../h5/plantaskDict';

let form = {
  tk_time: '',
  tk_type: '',
  tk_name: '',
  tk_memo: '',
};

export default {
  mixins: [student, plantaskDict],
  data() {
    return {
      loading: false,
      refresh: false,
      refresh1: false,
      refresh2: false,
      refresh3: false,
      disabled: false,
      dialogFormVisible: false,
      tab1: 'today',
      tab2: 'visit',
      tab3: 'visit-1',
      formType3: {},
      searchData: {
        roleid: '',
        searchTeacher: '',
        searchType: '',
        writeTeacher: '',
      },
      form: {
        tk_time: '',
        tk_type: '',
        tk_name: '',
        tk_memo: '',
      },
      students: [],
      options: [],
      rules: {
        tk_time: [
          {
            type: 'date', required: true, message: '请选择时间', trigger: 'change'
          }
        ],
        tk_type: [
          {
            required: true, message: '请选择任务类型', trigger: 'change', type: 'number'
          }
        ],
        tk_name: [
          { required: true, message: '请输入学生姓名', trigger: 'change' }
        ],
        tk_memo: [
          { required: true, message: '请输入计划任务说明', trigger: 'blur' }
        ]
      }
    };
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
    'jm-tableList': tableList,
    jmVisitFormDialog: visitFormDialog,
  },
  computed: {
    setDisabled() {
      return !!this.form.tk_id;
    }
  },
  methods: {
    fetchData() {
      this.changeStudentType();
      this.fetchplan();
      this.formType3 = this.dict.formType3.visit;
      this.changeWriteTeacher();
    },
    fetchplan() {
      this.$http
        ._get({
          url: '/index/plantask/plantaskInterface'
        })
        .then(({ data }) => {
          this.options = data;
        });
    },
    getStudent(query) {
      if (query !== '') {
        this.loading = true;
        this.$http
          ._post({
            url: '/index/plantask/searchName',
            data: {
              tk_name: query
            }
          })
          .then(({ data }) => {
            this.loading = false;
            this.students = data;
          });
      } else {
        this.students = [];
      }
    },
    changeTab() {
      this.refresh = true;
    },
    changeTab2() {
      this.formType3 = this.dict.formType3[this.tab2];
      this.tab3 = this.formType3[0].value;
      this.changeStudentType();
    },
    changeStudentType() {
      this.searchData.searchType = this.tab3;
      this.refresh1 = true;
    },
    changeWriteTeacher() {
      this.refresh2 = true;
    },
    changePlanningTeacher() {
      this.refresh3 = true;
    },
    getClass(row, column) {
      if (row.class !== '') {
        if (row.columns.indexOf(column) !== -1) {
          return row.class;
        }
      }
      return '';
    },
    sayTime() {
      console.log(this.form);
    },
    departmentAdd() {
      this.form = form;
      this.dialogFormVisible = true;
    },
    departmentEdit({ row }) {
      this.form = Object.assign({}, row);
      this.form.tk_type = row.tk_type_key;
      this.form.tk_time = new Date(row.tk_time);
      this.dialogFormVisible = true;
    },
    departmentDelete({ row }) {
      this.$confirm('确认处理?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http
          ._post({
            url: '/index/plantask/delPlan',
            data: {
              tk_id: row.tk_id
            }
          })
          .then(() => {
            this.refresh = true;
            this.$message({
              type: 'success',
              message: '处理成功!'
            });
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消处理'
        });
      });
    },
    departmentChangePass({ row }) {
      this.$confirm('确认处理?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http
          ._post({
            url: '/index/plantask/editPlan',
            data: {
              tk_id: row.tk_id,
              tk_pass: row.tk_pass1
            }
          })
          .then(() => {
            this.refresh = true;
            this.$message({
              type: 'success',
              message: '处理成功!'
            });
          });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消处理'
        });
      });
    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$http._post({
            url: '/index/Plantask/add',
            data: this.form,
          }).then((res) => {
            this.dialogFormVisible = false;
            if (res.result === 0) {
              this.refresh = true;
              this.form = {
                tk_id: '',
                tk_time: '',
                tk_type: '',
                tk_name: '',
                tk_memo: '',
              };
              this.$message({
                type: 'success',
                message: '创建成功!'
              });
            }
          });
        }
      });
    },
    cancel() {
      this.dialogFormVisible = false;
      this.form = {
        tk_time: '',
        tk_type: '',
        tk_name: '',
        tk_memo: '',
      };
    },
    finished() {
      switch (this.userOperateVisit) {
        case 'writeOperate':
          this.refresh2 = true;
          break;
        case 'planningOperate':
          this.refresh3 = true;
          break;
        default:
          break;
      }
    }
  },
  watch: {
    dialogFormVisible(val) {
      if (!val) {
        this.cancel();
      }
    },
    'searchData.roleid'(val) {
      console.log(val);
      this.changeTab2();
    }
  },
  created() {
    this.fetchData();
  }
};
</script>
